const weatherDescriptionTranslations = {
    '14 Days': {
        en: '14 Days',
        es: '14 Días',
        pt: '14 Dias',
    },
    '7 Days': {
        en: '7 Days',
        es: '7 Días',
        pt: '7 Dias',
    },
    Sleet: {
        en: 'Sleet',
        es: 'Aguanieve',
        pt: 'Granizo',
    },
    Now: {
        en: 'Now',
        es: 'Ahora',
        pt: 'Agora',
    },
    High: {
        en: 'High',
        es: 'Alto',
        pt: 'Alto',
    },
    'Pesticide Application': {
        en: 'Pesticide Application',
        es: 'Aplicación de Fitosanitarios',
        pt: 'Aplicação de produtos fitossanitários',
    },
    Fair: {
        en: 'Fair',
        es: 'Apto',
        pt: 'Apto',
    },
    Low: {
        en: 'Low',
        es: 'Bajo',
        pt: 'Baixo',
    },
    Haze: {
        en: 'Haze',
        es: 'Bruma',
        pt: 'Confusão',
    },
    Hot: {
        en: 'Hot',
        es: 'Caliente',
        pt: 'Quente',
    },
    Showers: {
        en: 'Showers',
        es: 'Chubascos',
        pt: 'Chuveiros',
    },
    'Scattered Showers': {
        en: 'Scattered Showers',
        es: 'Chubascos Dispersos',
        pt: 'Chuvas dispersas',
    },
    Breezy: {
        en: 'Breezy',
        es: 'Con Viento',
        pt: 'Com Vento',
    },
    Snowflakes: {
        en: 'Snowflakes',
        es: 'Copos de Nieve',
        pt: 'Flocos de neve',
    },
    Drifting: {
        en: 'Drifting',
        es: 'Deriva',
        pt: 'Deriva',
    },
    Clear: {
        en: 'Clear',
        es: 'Despejado',
        pt: 'Claro',
    },
    'Weather Status': {
        en: 'Weather Status',
        es: 'Estado del clima',
        pt: 'Estado do tempo',
    },
    'Status & Forecast': {
        en: 'Status & Forecast',
        es: 'Estados y pronóstico',
        pt: 'Status e previsões',
    },
    Evaporation: {
        en: 'Evaporation',
        es: 'Evaporación',
        pt: 'Evaporação',
    },
    'Expand Pesticide Application': {
        en: 'Expand Pesticide Application',
        es: 'Expandir aplicación de fitosanitarios',
        pt: 'Expandir a aplicação de produtos fitossanitários',
    },
    Extended: {
        en: 'Extended',
        es: 'Extendido',
        pt: 'Estendido',
    },
    'Frigid / Ice Crystals': {
        en: 'Frigid / Ice Crystals',
        es: 'Frígido / Cristales de Hielo',
        pt: 'Cristais Gelados / Gelados',
    },
    Hail: {
        en: 'Hail',
        es: 'Granizo',
        pt: 'Saudação',
    },
    Time: {
        en: 'Time',
        es: 'Hora',
        pt: 'Hora',
    },
    Humidity: {
        en: 'Humidity',
        es: 'Humedad',
        pt: 'Umidade',
    },
    Smoke: {
        en: 'Smoke',
        es: 'Humo',
        pt: 'Fumaça',
    },
    Hurricane: {
        en: 'Hurricane',
        es: 'Huracán',
        pt: 'Furacão',
    },
    Wash: {
        en: 'Wash',
        es: 'Lavado',
        pt: 'Lavagem',
    },
    Drizzle: {
        en: 'Drizzle',
        es: 'Llovizna',
        pt: 'Chuva',
    },
    'Freezing Drizzle': {
        en: 'Freezing Drizzle',
        es: 'Llovizna Helada',
        pt: 'Chuva congelante',
    },
    Rain: {
        en: 'Rain',
        es: 'Lluvia',
        pt: 'Chuva',
    },
    'Rain/Sleet': {
        en: 'Rain/Sleet',
        es: 'Lluvia / Aguanieve',
        pt: 'Chuva / Granizo',
    },
    'Rain/Snow': {
        en: 'Rain/Snow',
        es: 'Lluvia / Nieve',
        pt: 'Chuva / Neve',
    },
    'Freezing Rain': {
        en: 'Freezing Rain',
        es: 'Lluvia Helada',
        pt: 'Chuva de Gelo',
    },
    'Heavy Rain': {
        en: 'Heavy Rain',
        es: 'Lluvia Intensa',
        pt: 'Chuva Pesada',
    },
    'Rain and Hail Mixed': {
        en: 'Rain and Hail Mixed',
        es: 'Lluvia y Granizo Mezclados',
        pt: 'Chuva e granizo misturados',
    },
    Max: {
        en: 'Max',
        es: 'Max',
        pt: 'Máx',
    },
    'Mostly Cloudy': {
        en: 'Mostly Cloudy',
        es: 'Mayormente Nublado',
        pt: 'Principalmente nublado',
    },
    Medium: {
        en: 'Medium',
        es: 'Medio',
        pt: 'Metade',
    },
    'Medium-High': {
        en: 'Medium-High',
        es: 'Medio - Alto',
        pt: 'Médio - Alto',
    },
    'Wintry Mix': {
        en: 'Wintry Mix',
        es: 'Mezcla Invernal',
        pt: 'Mix de Inverno',
    },
    Min: {
        en: 'Min',
        es: 'Min',
        pt: 'Mínimo',
    },
    Foggy: {
        en: 'Foggy',
        es: 'Nebuloso',
        pt: 'Nebuloso',
    },
    Snowfall: {
        en: 'Snowfall',
        es: 'Nevadas',
        pt: 'Queda de neve',
    },
    'Scattered Snow': {
        en: 'Scattered Snow',
        es: 'Nevadas Dispersas',
        pt: 'Neve dispersa',
    },
    Snow: {
        en: 'Snow',
        es: 'Nieve',
        pt: 'Neve',
    },
    'Heavy Snow': {
        en: 'Heavy Snow',
        es: 'Nieve Intensa',
        pt: 'Neve Pesada',
    },
    'Windy Snow': {
        en: 'Windy Snow',
        es: 'Nieve Ventosa',
        pt: 'Neve Ventosa',
    },
    Unsuitable: {
        en: 'Unsuitable',
        es: 'No apto',
        pt: 'Não adequado',
    },
    'Not Available (N/A)': {
        en: 'Not Available (N/A)',
        es: 'No Disponible (N/D)',
        pt: 'Não disponível (N/A)',
    },
    Cloudy: {
        en: 'Cloudy',
        es: 'Nublado',
        pt: 'Nublado',
    },
    'Partly Cloudy': {
        en: 'Partly Cloudy',
        es: 'Parcialmente Nublado',
        pt: 'Parcialmente nublado',
    },
    'Blowing Dust / Thunderstorm Sand': {
        en: 'Blowing Dust / Thunderstorm Sand',
        es: 'Polvo Soplando / Tormenta de Arena',
        pt: 'Poeira soprando / Tempestade de areia',
    },
    Precipitation: {
        en: 'Precipitation',
        es: 'Precipitación',
        pt: 'Precipitação',
    },
    Forecast: {
        en: 'Forecast',
        es: 'Pronóstico',
        pt: 'Previsão',
    },
    'Next Hours': {
        en: 'Next Hours',
        es: 'Próximas Horas',
        pt: 'Próximas horas',
    },
    'Equipment Adjustments Required': {
        en: 'Equipment Adjustments Required',
        es: 'Requiere ajustes del equipo',
        pt: 'Requer ajustes de hardware',
    },
    'Frost Risk': {
        en: 'Frost Risk',
        es: 'Riesgo de heladas',
        pt: 'Risco de geada',
    },
    Sunny: {
        en: 'Sunny',
        es: 'Soleado',
        pt: 'Ensolarado',
    },
    'Sunny/Mostly Clear': {
        en: 'Sunny/Mostly Clear',
        es: 'Soleado / Mayormente Despejado',
        pt: 'Ensolarado / Geralmente limpo',
    },
    'Sunny/Mostly Sunny': {
        en: 'Sunny/Mostly Sunny',
        es: 'Soleado / Mayormente Soleado',
        pt: 'Ensolarado / Quase ensolarado',
    },
    'Snow Storm': {
        en: 'Snow Storm',
        es: 'Tormenta de Nieve',
        pt: 'Tempestade de neve',
    },
    'Tropical Storm': {
        en: 'Tropical Storm',
        es: 'Tormenta Tropical',
        pt: 'Tempestade tropical',
    },
    Thunderstorms: {
        en: 'Thunderstorms',
        es: 'Tormentas Eléctricas',
        pt: 'Tempestades',
    },
    'Isolated Thunderstorms': {
        en: 'Isolated Thunderstorms',
        es: 'Tormentas Eléctricas Aisladas',
        pt: 'Tempestades isoladas',
    },
    'Scattered Thunderstorms': {
        en: 'Scattered Thunderstorms',
        es: 'Tormentas Eléctricas Dispersas',
        pt: 'Tempestades Espalhadas',
    },
    'Severe Thunderstorms': {
        en: 'Severe Thunderstorms',
        es: 'Tormentas Fuertes',
        pt: 'Tempestades Severas',
    },
    Windy: {
        en: 'Windy',
        es: 'Ventoso',
        pt: 'Ventoso',
    },
    Wind: {
        en: 'Wind',
        es: 'Viento',
        pt: 'Vento',
    },
    Tornado: {
        en: 'Tornado',
        es: 'Tornado',
        pt: 'Tornado',
    },
    'Strong Storms': {
        en: 'Strong Storms',
        es: 'Tormentas Fuertes',
        pt: 'Tempestades Fortes',
    },
    'Rain / Snow': {
        en: 'Rain / Snow',
        es: 'Lluvia / Nieve',
        pt: 'Chuva / Neve',
    },
    'Rain / Sleet': {
        en: 'Rain / Sleet',
        es: 'Lluvia / Aguanieve',
        pt: 'Chuva / Granizo',
    },
    Flurries: {
        en: 'Flurries',
        es: 'Nevadas Dispersas',
        pt: 'Neve dispersa',
    },
    'Snow Showers': {
        en: 'Snow Showers',
        es: 'Nevadas',
        pt: 'Queda de neve',
    },
    'Blowing / Drifting Snow': {
        en: 'Blowing / Drifting Snow',
        es: 'Nieve Ventosa',
        pt: 'Neve Ventosa',
    },
    'Blowing Dust / Sandstorm': {
        en: 'Blowing Dust / Sandstorm',
        es: 'Polvo Soplando / Tormenta de Arena',
        pt: 'Poeira soprando / Tempestade de areia',
    },
    'Mostly Cloudy (Night)': {
        en: 'Mostly Cloudy (Night)',
        es: 'Mayormente Nublado',
        pt: 'Principalmente nublado',
    },
    'Mostly Cloudy (Day)': {
        en: 'Mostly Cloudy (Day)',
        es: 'Mayormente Nublado',
        pt: 'Principalmente nublado',
    },
    'Partly Cloudy (Night)': {
        en: 'Partly Cloudy (Night)',
        es: 'Parcialmente Nublado',
        pt: 'Parcialmente nublado',
    },
    'Partly Cloudy (Day)': {
        en: 'Partly Cloudy (Day)',
        es: 'Parcialmente Nublado',
        pt: 'Parcialmente nublado',
    },
    'Clear (Night)': {
        en: 'Clear (Night)',
        es: 'Despejado',
        pt: 'Claro',
    },
    'Sunny (Day)': {
        en: 'Sunny (Day)',
        es: 'Soleado',
        pt: 'Ensolarado',
    },
    'Fair / Mostly Clear (Night)': {
        en: 'Fair / Mostly Clear (Night)',
        es: 'Soleado / Mayormente Despejado',
        pt: 'Ensolarado / Geralmente limpo',
    },
    'Fair / Mostly Sunny (Day)': {
        en: 'Fair / Mostly Sunny (Day)',
        es: 'Soleado / Mayormente Soleado',
        pt: 'Ensolarado / Quase ensolarado',
    },
    'Mixed Rain and Hail': {
        en: 'Mixed Rain and Hail',
        es: 'Lluvia y Granizo Mezclados',
        pt: 'Chuva e granizo misturados',
    },
    'Scattered Snow Showers': {
        en: 'Scattered Snow Showers',
        es: 'Nevadas Dispersas',
        pt: 'Neve dispersa',
    },
    Blizzard: {
        en: 'Blizzard',
        es: 'Tormenta de Nieve',
        pt: 'Tempestade de neve',
    },
    'Scattered Showers (Night)': {
        en: 'Scattered Showers (Night)',
        es: 'Chubascos Dispersos',
        pt: 'Chuvas dispersas',
    },
    'Scattered Snow Showers (Night)': {
        en: 'Scattered Snow Showers (Night)',
        es: 'Nevadas Dispersas',
        pt: 'Neve dispersa',
    },
} as const;

export const getWeatherCodeData = (weatherCode: number | undefined) => {
    const weatherCodeData = {
        0: {
            description: 'Tornado',
        },
        1: {
            description: 'Tropical Storm',
        },
        2: {
            description: 'Hurricane',
        },
        3: {
            description: 'Strong Storms',
        },
        4: {
            description: 'Thunderstorms',
        },
        5: {
            description: 'Rain / Snow',
        },
        6: {
            description: 'Rain / Sleet',
        },
        7: {
            description: 'Wintry Mix',
        },
        8: {
            description: 'Freezing Drizzle',
        },
        9: {
            description: 'Drizzle',
        },
        10: {
            description: 'Freezing Rain',
        },
        11: {
            description: 'Showers',
        },
        12: {
            description: 'Rain',
        },
        13: {
            description: 'Flurries',
        },
        14: {
            description: 'Snow Showers',
        },
        15: {
            description: 'Blowing / Drifting Snow',
        },
        16: {
            description: 'Snow',
        },
        17: {
            description: 'Hail',
        },
        18: {
            description: 'Sleet',
        },
        19: {
            description: 'Blowing Dust / Sandstorm',
        },
        20: {
            description: 'Foggy',
        },
        21: {
            description: 'Haze',
        },
        22: {
            description: 'Smoke',
        },
        23: {
            description: 'Breezy',
        },
        24: {
            description: 'Windy',
        },
        25: {
            description: 'Frigid / Ice Crystals',
        },
        26: {
            description: 'Cloudy',
        },
        27: {
            description: 'Mostly Cloudy (Night)',
        },
        28: {
            description: 'Mostly Cloudy (Day)',
        },
        29: {
            description: 'Partly Cloudy (Night)',
        },
        30: {
            description: 'Partly Cloudy (Day)',
        },
        31: {
            description: 'Clear (Night)',
        },
        32: {
            description: 'Sunny (Day)',
        },
        33: {
            description: 'Fair / Mostly Clear (Night)',
        },
        34: {
            description: 'Fair / Mostly Sunny (Day)',
        },
        35: {
            description: 'Mixed Rain and Hail',
        },
        36: {
            description: 'Hot',
        },
        37: {
            description: 'Isolated Thunderstorms',
        },
        38: {
            description: 'Scattered Thunderstorms',
        },
        39: {
            description: 'Scattered Showers',
        },
        40: {
            description: 'Heavy Rain',
        },
        41: {
            description: 'Scattered Snow Showers',
        },
        42: {
            description: 'Heavy Snow',
        },
        43: {
            description: 'Blizzard',
        },
        44: {
            description: 'Not Available (N/A)',
        },
        45: {
            description: 'Scattered Showers (Night)',
        },
        46: {
            description: 'Scattered Snow Showers (Night)',
        },
        47: {
            description: 'Scattered Thunderstorms',
        },
    } as const;

    if (weatherCode === undefined || !weatherCodeData[weatherCode as keyof typeof weatherCodeData]) {
        return null;
    }

    return {
        description:
            weatherDescriptionTranslations[weatherCodeData[weatherCode as keyof typeof weatherCodeData].description],
        image: `https://doc.media.weather.com/products/icons/${weatherCode.toString().padStart(2, '0')}.png`,
    };
};
